import { ComboboxOption } from '@headlessui/react';

import Props from '@/components/@base/input/combobox/option/type';

const Option = ({ children, ...props }: Props) => {
  return <ComboboxOption {...props}>{children}</ComboboxOption>;
};

export default Option;
